export default __webpack_public_path__ + "static/media/skip-button.6503bfa5.png";